import stateCounties from "./state-counties.json";

export default {
  getStates: () => Object.keys(stateCounties),
  getCountiesByState: (state) => stateCounties[state],
};
